import React, { ReactElement } from "react";

function BowlIcon(): ReactElement {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="18" r="18" fill="#F0F0F5" />
            <path
                d="M20.95 9.93497C20.95 10.5441 20.4547 11.0379 19.8438 11.0379C19.2328 11.0379 18.7376 10.5441 18.7376 9.93497C18.7376 9.32583 19.2328 8.83203 19.8438 8.83203C20.4547 8.83203 20.95 9.32583 20.95 9.93497Z"
                fill="#5134B6"
            />
            <path
                d="M16.8939 13.9791C17.5049 13.9791 18.0001 13.4853 18.0001 12.8761C18.0001 12.267 17.5049 11.7732 16.8939 11.7732C16.283 11.7732 15.7877 12.267 15.7877 12.8761C15.7877 13.4853 16.283 13.9791 16.8939 13.9791Z"
                fill="#5134B6"
            />
            <path
                d="M25.7434 16.332H14.3046L13.207 12.4044C13.106 12.0283 12.6895 11.8129 12.2769 11.9231C11.8642 12.0333 11.6116 12.4276 11.7127 12.8036L12.9483 16.332H10.2567C10.1003 16.332 9.95019 16.394 9.83955 16.5043C9.72891 16.6146 9.66675 16.7643 9.66675 16.9203C9.66675 20.0036 10.5689 22.3677 12.0979 23.9648C13.6274 25.5624 15.7267 26.332 18.0001 26.332C20.2734 26.332 22.3728 25.5624 23.9022 23.9648C25.4312 22.3677 26.3334 20.0036 26.3334 16.9203C26.3334 16.7643 26.2713 16.6146 26.1606 16.5043C26.05 16.394 25.8999 16.332 25.7434 16.332Z"
                fill="#5134B6"
            />
            <path
                d="M21.3187 14.7144C21.9296 14.7144 22.4249 14.2206 22.4249 13.6114C22.4249 13.0023 21.9296 12.5085 21.3187 12.5085C20.7078 12.5085 20.2125 13.0023 20.2125 13.6114C20.2125 14.2206 20.7078 14.7144 21.3187 14.7144Z"
                fill="#5134B6"
            />
        </svg>
    );
}

export default BowlIcon;
